import { useState, useEffect, useContext, useRef } from 'react';

import { requestApi, useDebouncedValue } from '../../../../util/utility';
import { inquiryHelpSearchContext } from './InquiryHelpSearchContext';

import InquiryHelpSearchInput from './input/InquiryHelpSearchInput';
import InquiryHelpSearchAid from './aid/InquiryHelpSearchAid';

import { InquiryHelpModel } from '../../../../models/inquiry/InquiryHelpModel';


function InquiryHelpSearch() {
  const containerRef = useRef(null);

  const [query, setQuery] = useState<string>('');
  const [inquiryHelpList, setInquiryHelpList] = useState<InquiryHelpModel[]>([]);

  const [isDispAid, setIsDispAid] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // 検索：最後の入力から0.3秒後にAPI実行
  const debouncedQuery = useDebouncedValue(query, 300);


  // 検索API
  useEffect(() => {
    (async() => {
      // 検索：最後の入力から0.3秒後にAPI実行
      if (!debouncedQuery.trim()) return;

      setIsLoading(true);
      try {
        // API実行
        const resp = await requestApi({
          inc: '/backend/api/functions/user/inquiry/help/search',
          query: query,
        });
        // 取得データの格納
        setInquiryHelpList(resp.inquiryHelpList);
      } catch(err) {
        if (err instanceof Error) {
          console.warn(err.message);
        }
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 100)
      }
    })()
  }, [debouncedQuery])



  const contextVal = {
    containerRef,
    query: query,
    setQuery: setQuery,
    inquiryHelpList: inquiryHelpList,
    isDispAid: isDispAid,
    setIsDispAid: setIsDispAid,
    isLoading: isLoading,
    setIsLoading: setIsLoading,
  }


  return (
    <inquiryHelpSearchContext.Provider value={contextVal}>
      <div
        ref={containerRef} className="relative"
        style={{margin: '0 auto'}}
      >

        {/* 入力欄 */}
        <InquiryHelpSearchInput />

        {isDispAid &&
          <>
            {/* 入力補助 */}
            <InquiryHelpSearchAid />
          </>
        }

      </div>
    </inquiryHelpSearchContext.Provider>
  );
}
  
export default InquiryHelpSearch;